<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import pm from "./components/common/protocolManager";
import eventBus from "./components/common/eventBus";
export default {
  name: "App",
  data: () => ({
    message: "App.vue",
    // dialogTableVisible: true
  }),

  methods: {
    ...mapMutations(["setNewsList", "setNoticeList", "setAdmin" ]),
    changeBoardList() {
      this.reqBoardList();
    },
    reqBoardList() {
      console.log("getBoardList");
      let url = `noticeList`;

      pm.get(url)
        .then(result => {
          console.log("A=reqBoardList - ok");
          let tempNoticeList = [];
          let tempNewsList = [];

          if (result.list.length) {
            for (let i = 0; i < result.list.length; i++) {
              if (result.list[i].files && result.list[i].files.bgImage) {
                result.list[i].MAIN_IMG =
                  pm.NAS_URL + result.list[i].files.bgImage[0].filename;
              }

              // 게시판 타입 = 0 : 공지사항, 1 : 소식,
              if (result.list[i].type == 0) {
                // 공지사항
                tempNoticeList.push(result.list[i]);
              } else {
                // 소식
                tempNewsList.push(result.list[i]);
              }

            }
            this.setNoticeList(tempNoticeList);
            this.setNewsList(tempNewsList);


            console.log('공지사항 tempNoticeList length = ' + tempNoticeList.length);
            console.log('소식 tempNewsList length = ' + tempNewsList.length);

          } else {
            this.bShowMore = false;
          }
        })
        .catch(error => {
          console.log("error");
          alert("reqBoardList 에러");
        });
    },


  },
  computed: {
    ...mapGetters(["getNewsList",])
  },
  destroyed() {
    console.log("destroyed:App.vue");
    eventBus.$off("EVENT_CHANGE_BOARD_LIST");
  },
  mounted() {
    eventBus.$on("EVENT_CHANGE_BOARD_LIST", () => {
      console.log("EVENT_CHANGE_BOARD_LIST_App.vue");
      this.changeBoardList();
    });

  },
  created() {
    console.log("created - " + this.message);

    if (localStorage.authToken) {
      this.setAdmin(true);
      pm.setAuthToken(localStorage.authToken);
    }

    this.changeBoardList();
  }
};
</script>




// WEBPACK FOOTER //
// src/App.vue